export const ACTION_LABEL = 'recently viewed';
export const SRC_SET_SIZES_ITEM_TILE = '(max-width:768px) 33vw, 16vw';
